
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAdminStatus } from './useAdminStatus';

export const useDashboardCore = () => {
  const location = useLocation();
  const { isAdmin, isLoading: adminStatusLoading } = useAdminStatus();
  
  // Check if we have state with an activeTab from navigation, default to 'clients'
  const initialTab = location.state?.activeTab || 'clients';
  const [activeTab, setActiveTab] = useState<string>(initialTab);
  
  // Update active tab when navigation state changes
  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  return {
    isAdmin,
    adminStatusLoading,
    activeTab,
    setActiveTab
  };
};
